import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/redux/store";
import { logout } from "../auth/AuthSlice";

interface HomeState {
  isLoading: boolean;
  error: string | null;
}

const initialState: HomeState = {
  isLoading: false,
  error: null,
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setLoading, setError, resetState } = homeSlice.actions;

export const homeSelector = (state: RootState) => state.home;

export const homeReducer = homeSlice.reducer;
export default homeSlice.reducer;
